import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { primitiveTypeUniq } from '@mews/fp';
import { getCurrentEnterpriseReservationsByIds } from '@mews-commander/legacy-entities/src/selectors/reservations';
import { useRatesQuery } from '@mews-commander/legacy-entities/src/queries/rates';
import { useCommanderSelector } from '@mews-commander/utils';

export const useDefaultRateIdForNewReservation = (reservationIds: string[], serviceId: string) => {
    const reservations = useCommanderSelector((state) =>
        getCurrentEnterpriseReservationsByIds(state, { ids: reservationIds })
    );
    const enterpriseId = useCurrentEnterpriseId();
    const ratesQuery = useRatesQuery(enterpriseId, serviceId);

    const uniqueRateIds = pipe(
        reservations,
        array.map((r) => r.rateId),
        primitiveTypeUniq
    );

    return uniqueRateIds.length === 1 ? uniqueRateIds[0] : ratesQuery.data?.defaultRate?.id ?? '';
};
